import React from "react";
import PropTypes from "prop-types";
import CourseActionButton from "../Buttons/CourseActionButton";
import { assignmentTypes, courseTypes } from "../../constants";
import { ChangeButton, ReserveTimeButton } from "../Buttons";
import { useTranslation } from "react-i18next";
import RemoveButton from "../Buttons/RemoveButton";

const CourseCardButtons = ({
  assignmentType,
  courseType,
  hasActiveVersions,
  isAssigned,
  isEnrolled,
  isInstructorForCourse,
  isStarted,
  onAddToCoursesClick,
  onChangeEnrollmentClick,
  onDeleteUserAssignment,
  onEnrollClick,
  onReserveTimeClick,
  onResumeCourseClick,
  prereqs,
  startDate,
  endDate,
  iltClassType
}) => {
  const { t } = useTranslation();

  let buttons = [];

  buttons.push(
    <CourseActionButton
      courseType={courseType}
      isAssigned={isAssigned}
      isStarted={isStarted}
      isEnrolled={isEnrolled}
      prereqs={prereqs}
      onEnrollClick={onEnrollClick}
      onAddToCoursesClick={onAddToCoursesClick}
      onResumeCourseClick={onResumeCourseClick}
      isInstructorForCourse={isInstructorForCourse}
      startDate={startDate}
      endDate={endDate}
      iltClassType={iltClassType}
      key="CourseActionButton"
    />
  );

  if (hasActiveVersions && isAssigned && onReserveTimeClick) {
    buttons.push(
      <ReserveTimeButton
        disabled={prereqs?.length > 0}
        key="ReserveTimeButton"
        onClick={onReserveTimeClick}
      />
    );
  }

  if (
    hasActiveVersions &&
    isEnrolled &&
    courseType === courseTypes.ilt &&
    assignmentType !== assignmentTypes.forceEnrolled
  ) {
    buttons.push(
      <ChangeButton
        key="ChangeButton"
        text={t("learningPathListView.changeEnrollmentBtn")}
        onClick={onChangeEnrollmentClick}
      />
    );
  }

  if (isAssigned && assignmentType === assignmentTypes.self) {
    buttons.push(
      <RemoveButton key="RemoveButton" onClick={onDeleteUserAssignment} />
    );
  }

  return buttons;
};

export default CourseCardButtons;

CourseCardButtons.propTypes = {
  assignmentType: PropTypes.oneOf(Object.values(assignmentTypes)),
  courseType: PropTypes.oneOf(Object.values(courseTypes)),
  hasActiveVersions: PropTypes.bool,
  isAssigned: PropTypes.bool,
  isEnrolled: PropTypes.bool,
  isInstructorForCourse: PropTypes.bool,
  isStarted: PropTypes.bool,
  onAddToCoursesClick: PropTypes.func,
  onChangeEnrollmentClick: PropTypes.func,
  onDeleteUserAssignment: PropTypes.func,
  onEnrollClick: PropTypes.func,
  onReserveTimeClick: PropTypes.func,
  onResumeCourseClick: PropTypes.func,
  prereqs: PropTypes.arrayOf(PropTypes.string),
  startDate: PropTypes.string,
  endDate: PropTypes.string,
  iltClassType: PropTypes.string
};
